var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-trust-order-detail',{staticClass:"pt-trust-order-detail__page",attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }